
































































import toBgClClass from '@/filters/to-bg-cl-class'
import Transaction from '@/mixins/Translation'
import {Header} from 'element-ui'
import {Component, Mixins, Prop} from 'vue-property-decorator'

@Component({
  components: {
    [Header.name]: Header,
  },
  methods: {
    toBgClClass
  }
})
export default class HeaderLayout extends Mixins(Transaction) {
  @Prop() height: number
  @Prop({default: 'white'}) background: string
  @Prop({default: false}) isBorder: string

  get borderClass() {
    return this.isBorder ? 'k-border-bottom-gray-100' : 'k-border-bottom-white'
  }

}
